// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2uT_J","choiceBoxes":"toolbarselects_choiceBoxes__3YwKf","simpleField":"toolbarselects_simpleField__3pwWw"};